import './team-intro.scss';
import Swiper from 'swiper/bundle';

export default () => {
	//Swiper
	new Swiper('.js-team-intro-slider', {
		speed: 500,
		loop: true,
		slidesPerView: 1,
		navigation: {
			nextEl: ".team-intro-button-next",
			prevEl: ".team-intro-button-prev",
		},
	});

};
